import { render, staticRenderFns } from "./SalesSettings.vue?vue&type=template&id=82313f72&scoped=true&"
import script from "./SalesSettings.vue?vue&type=script&lang=js&"
export * from "./SalesSettings.vue?vue&type=script&lang=js&"
import style0 from "./SalesSettings.vue?vue&type=style&index=0&id=82313f72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82313f72",
  null
  
)

export default component.exports